import { ChevronRight } from "lucide-react"
import { useNavigate } from "react-router-dom"


export default function AlunoFicha({aluno}){
    const navigate = useNavigate()
    return(
        <div className="card-aluno" onClick={() => {
            navigate(`/alunos/${aluno.id}`,{state:aluno})
        }}>
            <div className="card-avatar">{aluno.nome[0]}</div>
            <div className="card-info">
                <span className="card-nome">{aluno.nome}</span>
                <span className="card-turma">{aluno.turmaNome ? aluno.turmaNome:'Sem turma'}</span>
            </div>
            <ChevronRight className="card-arrow" size={20} />
        </div>
    )
}